import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import VerifyUserOtpComponent from "../../components/VerifyUserOtp";
import PasswordExpiryComponent from "../../containers/Login/PasswordExpiry";
import { useDispatch, useSelector } from "react-redux";
import history from "../../utilities/history"
import * as loginActions from "../../redux/actions/loginActions";

import {
  MODAL_SIZE
} from "../../App.config";
import TermsAndConditionsPage from "../Login/TermsAndConditions";



const VerifyUserOtp = (props, context) => {
  //   const profileReducer = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);
  const loginAction = bindActionCreators(loginActions, dispatch);

  const loginReducer = useSelector((state) => state.loginReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const notificationReducer = useSelector((state) => state.notification);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const openPasswordExpiryModal = () => {
    if (profileReducer && profileReducer.managersDetails) {
      props.openSetModalAction(<PasswordExpiryComponent email={profileReducer.managersDetails.email} />, MODAL_SIZE.MODAL_SM);
    }
  }

  const openTermsAndConditionPage = () => {
    openSetModal(<TermsAndConditionsPage onAccept={onAccept} closeRemoveModal={closeRemoveModal} />, MODAL_SIZE.MODAL_MD)
  }

  const onAccept = () => {
    history.push("dashboard");
    // /// Need to show terms and conditions modal every login 
    // loginAction.updateTnCStatus(profileReducer.managersDetails,
    //   () => {
    //     closeRemoveModal();
    //   });
  }

  const handleSubmit = (data) => {

    if (profileReducer && profileReducer.managersDetails)
      loginAction.verifyUserOtp(profileReducer.managersDetails, data.OTP, openPasswordExpiryModal,
        () => {
          closeRemoveModal();
        }, notificationReducer, () => { openTermsAndConditionPage() });
  }


  // Close modal component on change component
  // useEffect(() => {
  //   return () => {
  //     closeRemoveModal();
  //   };
  // }, []);

  return (
    <VerifyUserOtpComponent
      context={context}
      closeRemoveModal={closeRemoveModal}
      openSetModal={openSetModal}
      handleSubmit={handleSubmit}
      {...props}
    //   lastLoginDetails={profileReducer.lastLoginDetails}
    />
  );
};


export default VerifyUserOtp;
